import { render, staticRenderFns } from "./GroupMemberBar.vue?vue&type=template&id=153e52d5&scoped=true"
import script from "./GroupMemberBar.vue?vue&type=script&lang=js"
export * from "./GroupMemberBar.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberBar.vue?vue&type=style&index=0&id=153e52d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e52d5",
  null
  
)

export default component.exports